import { STATE_MAP } from './constants';

export const getUSState = (stateProvince: string): string =>
  STATE_MAP[stateProvince] || stateProvince;
